import axios from 'axios';
import React, { useEffect, useState } from 'react';

const UserRegistration = ({ onRegistered }) => {
  const [username, setUsername] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [referredBy, setReferredBy] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const merchantData = JSON.parse(localStorage.getItem("userLogin"));
    if (merchantData) {
      setEmail(merchantData.email);
      setPassword(merchantData.email);
      setUsername(merchantData.name);
    }
  }, []);

  const userformHandling = async (e) => {
    e.preventDefault();

    if (!/^[0-9]{10}$/.test(mobileNumber)) {
      setError("Mobile number must be exactly 10 digits and only contain numbers");
      return;
    }

    const payload = {
      username: username?.trim() || "",
      email: email?.trim() || "",
      mobileNumber: mobileNumber?.trim() || "",
      password: password || "",
      address: address?.trim() || "",
      referralCode: referralCode?.trim() || "",
      referredBy: referredBy?.trim() || "",
      registeredDate: new Date().toISOString(),
    };

    try {
      const response = await axios.post(
        'https://api.bakpoket.com/api/UserDetail1/register',
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response?.data) {
        localStorage.setItem("userDashboardLogin", JSON.stringify(response.data));
        localStorage.setItem("googleLogin", false);
        alert('User registered successfully!');

        // ✅ switch to dashboard immediately
        if (onRegistered) onRegistered();
      }
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message || 'Registration failed.');
      } else {
        setError('Sign-up failed. Please check your connection.');
      }
    }
  };

  return (
    <div className="container my-3 d-flex align-items-center justify-content-center flex-column" style={{ height: "60vh" }}>
      <div className="card" style={{ maxWidth : "500px" }}>
        <div className="card-body">
          <h4 className="card-title text-center">Enter User Details</h4>
          <form onSubmit={userformHandling}>
            <div className="mb-3">
              <label htmlFor="username" className="ps-2 mb-1">User Name:</label>
              <input type="text" className="form-control" id="username" readOnly disabled value={username} />
            </div>
            <div className="mb-3">
              <label className="text-start ps-2 mb-1">Email:</label>
              <input type="text" className="form-control" readOnly disabled value={email} />
            </div>
            <div className="mb-3">
              <label htmlFor="mobile" className="ps-2 mb-1">Mobile Number:</label>
              <input type="text" className="form-control" id="mobile" placeholder="Enter Mobile Number" onChange={(e) => setMobileNumber(e.target.value)} />
            </div>
            {error && <p className="text-danger mt-1 text-center" style={{ fontSize: "12px" }}>{error}</p>}
            <div className="w-100 d-flex justify-content-center">
              <button type="submit" className="btn rounded-pill px-4 py-2" style={{ width: "70%" }}>Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
